import {
  INBOUND_ORDER_STATUSES,
  INBOUND_ORDER_TYPES,
  isStorableCalendarDate,
  type InboundOrderStatus,
  type InboundOrderType,
  optionalUuidString,
} from '@nudool/shared';

export type ReceivingDeskSearch = {
  type?: InboundOrderType;
  status?: InboundOrderStatus;
  expectedDate?: string;
  late?: boolean;
  destinationWarehouseId?: string;
  sourceId?: string;
  brandId?: string;
};

function oneOf<Value extends string>(values: readonly Value[], raw: unknown): Value | undefined {
  return values.find((value) => value === raw);
}

function uuidOrUndefined(raw: unknown): string | undefined {
  const value = typeof raw === 'string' ? raw.trim() : '';
  return optionalUuidString('Invalid id').safeParse(value).success && value
    ? value.toLowerCase()
    : undefined;
}

function dateOrUndefined(raw: unknown): string | undefined {
  const value = typeof raw === 'string' ? raw.trim() : '';
  return isStorableCalendarDate(value) ? value : undefined;
}

export function parseReceivingDeskSearch(search: Record<string, unknown>): ReceivingDeskSearch {
  return {
    type: oneOf(INBOUND_ORDER_TYPES, search.type),
    status: oneOf(INBOUND_ORDER_STATUSES, search.status),
    expectedDate: dateOrUndefined(search.expectedDate),
    late: search.late === true || search.late === 'true' ? true : undefined,
    destinationWarehouseId: uuidOrUndefined(search.destinationWarehouseId),
    sourceId: uuidOrUndefined(search.sourceId),
    brandId: uuidOrUndefined(search.brandId),
  };
}
